<template>
	<div  v-loading="loading" id="knowindex">
		<div>
			<Header></Header>
			<TwiceTitle  @key="change"></TwiceTitle>
			<div class="container">
				<div class="class-box">
					<div class="class-list">
						<div class="name">影音分类：</div>
							<div v-for="(item,index) in video" v-bind:key="item.id"
							 @click="companyTypeEvent(index,item.id)" ref="companyTypeDOM"
							 :class="index == 0? 'first-selectd' : 'selectd'">{{item.name}}
							 </div>
					</div>
					<!--二级分类-->
					<div style="padding-left:95px" class="class-list">
						<div v-for="(item,index) in childrenCategory" v-bind:key="item.id"
							 @click="childrenCategoryEvent(index,item.id)" ref="childrenCategoryDOM"
							 :class="index == 0? 'first-selectd' : 'selectd'">{{item.name}}</div>
					</div>
					<div class="class-list">
						<div class="name">品牌分类：</div>
						<div  ref="companyType"　v-for="(item,index) in brand" v-bind:key="item.id"
							  :class="index == 0? 'first-selectd' : 'selectd'" @click="companyType(index,item.id)">{{item.name}}</div>
					</div>
				</div>

				<div class="sort-box">
					<div class="sort-name">
						<div style="display:flex;" v-for="(item,index) in sort" v-bind:key="item.id"
						@click="changePrice(index)"   ref="brandType"
						 :class="index == 0 ? 'first-sort' : 'sort-all'">
							<div>{{item}}</div>
								  <img style="margin:auto;width:8px;height:8px" :src="index==0?imgBotY:imgBot" alt="">
							<div class="vertical"></div>
						</div>
					</div>
					<div class="equipment">
						共{{total}}件器材
					</div>
				</div>
				<div class='none'  v-if="list.length == 0">
				<img style="width:200px;height:250px" src="/static/image/null.svg" alt="">
				<div>非常抱歉！没有找到符合条件的商品!</div>
				<div style="font-size:14px;">您可以尝试：修改筛选条件或输入新的关键字重新查找</div>
				</div>
				<div class="list-box">
					<div class="scale-pic" v-for="item in list" v-bind:key="item.id">
					<div class="more-pic" >
						<router-link style="text-decoration:none;color:#444444" :to="{ path: '/knowshop/detail/'+item.id }" >
							<div class="cover-img">
								<div class="pic-box"  :style="{backgroundImage:item.cover_img}"></div>
							</div>
							<div class="title">{{item.title}}</div>
							<div style="display:flex;margin-top: 12px;justify-content: space-between;align-items:center;">
							<div v-if="item.lowestprice != 0" style="font-size:20px;color:#F9BE04;padding-left:5px" ><span style="font-size:14px	">￥</span>{{item.lowestprice}}</div>
							<div v-if="item.lowestprice == 0" style="font-size:17px;color:#F9BE04;padding-left:5px" >暂无报价</div>
							<div style="font-size: 12px;color: #B1B1B1;padding-right:5px">{{item.shoplink}}条商品链接</div>
							</div>
						</router-link>
					</div>
					</div>
				</div>
				<div  v-if="list.length != 0" class="pagination" ref="pagination">
					<el-pagination
							background
							@current-change="changePage"
							:current-page.sync="page"
							:page-size="12"
							layout="prev, pager, next"
							:total="total">
					</el-pagination>
					<span>共{{pagenum.last_page}}页</span>
				</div>
			</div>
			<Foot></Foot>
		</div>
	</div>
</template>

<script>
	import Foot from '@/components/common/Foot'
	import Header from '@/components/knowshop/Header'
	import TwiceTitle from '@/components/knowshop/TwiceTitle'
	import {getBrandList} from '@/api/secendHands/axios'
	import {getVideoList} from '@/api/secendHands/axios'
	import {tabSwitch} from '@/common/js/common'
	import Mixin from '@/common/js/mixin'
	import {setCookie,getCookie,clearCookie} from '@/common/js/common'
	export default {
		mixins: [Mixin],
		name: "twicehands-index",
		components:{
			Foot,
			Header,
			TwiceTitle
		},
		data (){
			return {
				uid:getCookie('user_info') ? JSON.parse(getCookie('user_info')).uid : '',
				shop:[],
				brand:[],
				video:[],
				list:[],
				key:'',
				total:0,
				page:1,
				pagenum:[],
				sort:[
					'人气','价格'
				],
				order:'',
				isA:false,
				childrenCategorys:[],//子分类 总集合
				childrenCategory:[],
				category:'',//分类参数
				brand_id:'',
				defaultImg: 'this.src="' + require('../../assets/Bitmap.png') + '"',
				loading:true,
				imgTopY:'/static/image/top.png',
				imgBotY:'/static/image/bot.png',
				imgBot:'/static/image/xx.png'
			}
		},
		created () {
			this.getBrandList()
			this.getVideoList()
			this.getShopList()
		},
		methods:{
			getBrandList: function () {
				this.$get('/apis/discern/discernBrand').then((res)=>{
					if(res){
						this.brand = res.data
						//头部推入全部选项
						this.brand.unshift({id:'',name:'全部',is_has_son:0});
					}
				})
			},
			getVideoList: function () {
				let _this=this;
				this.$get('/apis/discern/discernCategory/parent/0').then((res)=>{
					if(res){
						this.video = res.data
						//头部推入全部选项
						this.video.unshift({id:'',is_has_son:0,name:'全部',parent_id:0,_children:[]});
						res.data.forEach(function(value,index){
							// 填充二级分类
							if(value._children.length !== 0){
								value._children.forEach(function(values,indexs){
									_this.childrenCategorys.push({id:values.id,name:values.name,pid:values.parent_id});
								})
							}
						});
					}
				})
			},
			// 获取商品列表
			getShopList: function (value) {
				this.$get('/apis/discern/discern', {
					params: {
						brand: this.brand_id,
						key: this.keywords,
						category: this.category,
						order:this.order,
						page:this.page,
					}
				}).then((res)=>{
					if(res){
						this.list = res.data.data
						this.pagenum=res.data
						// 分页参数
						this.total = res.data.total
						this.page = res.data.current_page
						this.loading = false
					}
				})
			},
			//选择一级分类
			companyTypeEvent(index,id) {
				let _this=this;
				tabSwitch(this,index,'companyTypeDOM');
				this.category = id
				//取子分类
				_this.childrenCategory=[];
				_this.childrenCategorys.forEach(function(value,index){
					if(id==value.pid){
						_this.childrenCategory.push({id:value.id,name:value.name,pid:value.parent_id});
					}
				})
				if(index!=0){
					//头部推入全部选项
					this.childrenCategory.unshift({id:id,is_has_son:0,name:'全部',parent_id:0,_children:[]});
				}
				this.category = id
				//二级分类变色
				this.childrenCategoryEvent(0,id)
			},
			//选择二级分类
			childrenCategoryEvent(index,id){
				tabSwitch(this,index,'childrenCategoryDOM');
				this.category = id
				this.getShopList()
			},
			//选择品牌
			companyType(index,id) {
				this.brand_id=id;
				tabSwitch(this,index,'companyType');
				this.getShopList()
			},
			change : function (value) {
				const that =this;
				that.key = value
				that.getShopList(that.key)
			},
			changePrice(index) {
				this.$refs.brandType.forEach((ele, Mindex) => {
					index === Mindex ? (this.$refs.brandType[Mindex].style.color = '#F9BE04')
						: (this.$refs.brandType[Mindex].style.color = '#979797')
				})
				this.isA = !this.isA
				let imgTopY='/static/image/top.png';
				let imgBotY='/static/image/bot.png';
				let imgBot='/static/image/xx.png'
				if (index == 0 && this.isA == false){
					this.order = 'goods_hits desc';
						this.$refs.brandType[index].childNodes[2].src=imgBotY;
				}if (index == 0 && this.isA  == true){
					this.order = 'goods_hits asc';
					this.$refs.brandType[index].childNodes[2].src=imgTopY;
				}
				if (index == 1 && this.isA == false){
					this.order = 'price desc';
					this.$refs.brandType[index].childNodes[2].src=imgBotY;
				}if (index == 1 && this.isA  == true){
					this.order = 'price asc';
					this.$refs.brandType[index].childNodes[2].src=imgTopY;
				}
				//当前页码置1
				//当前页码置1
				if(this.page!=1){
					document.querySelector('.pagination li:first-child').click()
				}else{
					this.getShopList();
				}
				this.$refs.brandType.forEach(function(value,indexs){
					if(indexs!=index){
						value.childNodes[2].src=imgBot;
					}
				})
			},
			changePage(currentPage){
				this.page = currentPage;
				this.getShopList();
				document.body.scrollTop = document.documentElement.scrollTop = 0
			},
		},
		watch:{
			keywords:function(){
				this.page = 1
				this.getShopList()
			}
		},
		computed: {
			keywords: function () {
				return this.$route.query.kw;
			}
		}
	}
</script>
<style >
	body{
		margin: 0px;
	}
	#knowindex{
		min-width: 1200px;
	}
	.el-submenu .el-menu{
		z-index: 1;
	}
	#knowindex .container{
		box-sizing: border-box;
		width: 1200px;
		margin: auto;
	}
	#knowindex .class-box{
		background: #fcfcfc;
		height: auto;
		padding-bottom: 25px;
	}
	.none{
		text-align: center;
		color: #555;
		font-size: 18px;
		margin: auto;
		min-height: 400px;
	}
	#knowindex .name{
		margin-top: 25px;
		margin-left: 13px;
	}
	#knowindex .selectd{
		border: 1px solid #D3D3D2;
		border-radius: 8px;
		margin-top: 25px;
		padding: 0 12px;
		font-size: 12px;
		color: #D3D3D2;
		margin-left: 20px;
		cursor:pointer ;
		height: 20px;
		line-height: 20px;
	}
	#knowindex .first-selectd{
		border: 1px solid #F9BE04;
		border-radius: 8px;
		color: #F9BE04;
		margin-top: 25px;
		padding: 0 12px;
		font-size: 12px;
		margin-left: 20px;
		cursor:pointer ;
		height: 20px;
		line-height: 20px;

	}
	#knowindex .search-money{
		margin-top: 25px;
		margin-left: 20px;
	}
	#knowindex .search-money input{
		border: 1px solid #d3d3d2;
		background: #EDEDED;
		width: 75px;
		height: 21px;
		font-size: 12px;
		text-align: center;
		border-radius: 2px;
	}
	#knowindex .search-money span{
		color: #d3d3d2
	}
	#knowindex .sort-box{
		display: flex;
		justify-content: space-between;
		border: 1px solid #f7f7f7;
		height: 42px;
		line-height: 42px;
		margin-top: 30px;
	}
	#knowindex .sort-name{
		display: flex;
	}
	#knowindex .sort-all{
		width: 135px;
		font-size: 12px;
		color: #979797;
		margin-left: 43px;
	}
	#knowindex .sort-all img{
		width: 6px;
		height: 6px;
		padding-left: 5px;
	}
	#knowindex .equipment{
		font-size: 12px;
		color: #979797;
		margin-right: 22px;
	}
	#knowindex .first-sort{
		color: #F9BE04;
		width: 135px;
		font-size: 12px;
		margin-left: 43px;
		cursor:pointer;
	}
	#knowindex .vertical{
		background: #CECECE;
		width: 1px;
		height: 26px;
		margin-top: 8px;
	}
	#knowindex .pic-box{
		width: 260px;
		height: 217px;
		background-size: cover;
  		background-position: 50%;
	}

	#knowindex .more-pic .pic-box {
		transition: all 0.5s ease-out;
		transform-origin:center;
	}
	#knowindex .more-pic:hover .title {
		font-size: 14px;
	}
	.cover-img{
		overflow: hidden;
		height: 217px;
	}
	.cover-img .pic-box:hover{
		transform: scale(1.1);
		transition: all .5s ease-out;
		
	}
	.more-pic:hover{
		box-shadow: 0 0 2px 0 rgba(0,0,0,.12), 0 2px 2px 0 rgba(0,0,0,.12);
	}
	#knowindex .more-pic .title {
		padding-left: 5px;
		transition: all 0.5s ease-out;
		transform-origin:center;
		font-size: 14px;
		color: #363636;
		line-height: 21px;
		text-align: center;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		transform: scale(1.2);
		margin-right: 12px;
		width: 217px;
		padding-left: 20px
	}
	.el-pagination.is-background .el-pager li.number:hover{
		color:#f9be04;
	}

	.el-pagination.is-background .el-pager li.active:hover{
		color:#fff;
	}
	#knowindex .more-pic{
		float: left;
		max-width: 280px;
		width: 260px;
		margin-top: 20px;
		margin-left: 20px;
		height: 300px;
		overflow: hidden;
	}
	#knowindex .sort-box{
		display: flex;
		justify-content: space-between;
		border: 1px solid #f7f7f7;
		height: 42px;
		line-height: 42px;
	}
	#knowindex .sort-name{
		display: flex;
	}
	.el-submenu{
		top:-26px !important 
	}
	#knowindex .sort-all{
		width: 135px;
		font-size: 12px;
		color: #979797;
		margin-left: 43px;
		cursor:pointer 
	}
	#knowindex .sort-all img{
		width: 6px;
		height: 6px;
		padding-left: 5px;
	}
	#knowindex .equipment{
		font-size: 12px;
		color: #979797;
		margin-right: 22px;
	}
	#knowindex .first-sort{
		color: #F9BE04;
	}
	#knowindex .vertical{
		background: #CECECE;
		width: 1px;
		height: 26px;
		margin-top: 8px;
	}
	#knowindex .list-box{
		width: 1200px;
		margin: auto;
		min-height: 800px;
		display: flex;
		flex-wrap: wrap;
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background: rgba(0,0,0,0.00);
		border: 1px solid #F9BE04;
	}
	.el-pagination.is-background .el-pager li{
		border: 1px solid #D5D5D5;
		color: #D5D5D5;
	}
	#knowindex .pagination{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	#knowindex .pagination input{
		width: 28px;
		border: 1px solid #D5D5D5;
		height: 26px;
		margin-left: 4px;
		margin-right: 4px;
	}
	#knowindex .pagination span{
		font-size: 14px;
		color: #D5D5D5;
		letter-spacing: 0;
		line-height: 18px;
		margin-left: 11px;
	}
	#knowindex .pagination-button{
		color: #fff;
		background: #F9BE04;
		box-shadow: 0 2px 4px 0 rgba(200,200,200,0.50);
		border-radius: 2px 2px 2px 0 2px;
		border: none;
		height: 30px;
		width: 65px;
		margin-left: 8px;
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background: #F9BE04;
	}
</style>


// WEBPACK FOOTER //
// src/components/knowshop/Index.vue